import packContentsModalTemplate from './packContentsModal.hbs';
import * as toastUtil from '/source/js/utils/toastUtil';
import * as productService from '/source/js/services/productService';
import * as shareLinksService from '/source/js/services/shareLinksService';
import { loadSpinner, stopSpinner } from '/source/_patterns/01-components/spinner/spinner';

const GENERIC_ERROR_MESSAGE = "We're sorry, we were unable to process your request. Please try again.";

export async function showPackContents(e) {
    e.preventDefault();
    const urlParams = new URLSearchParams(window.location.search);
    const shareCode = urlParams.get('shareCode') || urlParams.get('sharecode');
    const productId = $(this).data('productid');
    const shareLinkProductId = $(this).data('sharelinkproductid');
    fetchPackContents(shareCode, productId, shareLinkProductId);
}

async function fetchPackContents(shareCode, productId, shareLinkProductId) {
    try {
        loadSpinner();

        const result = await shareLinksService.GetPackComponents({ shareCode, productId, shareLinkProductId });

        if(result && result.IsSuccessful && result.PackProducts && result.PackProducts.length) {
            showPackContentsModal(result);
        } else {
            const message = result.ErrorMessage || GENERIC_ERROR_MESSAGE;
            toastUtil.Error(message, 3000);
            console.error(`[fetchPackContents] unable to retreive pack contents for shareCode ${shareCode}, productId ${productId} and shareLinkProductId ${shareLinkProductId}`, result);
        }
    } catch (ex) {
        toastUtil.Error(GENERIC_ERROR_MESSAGE, 3000);
        console.error(ex);
    }

    stopSpinner();
}

export async function showDefaultPackContents(e) {
    e.preventDefault();
    const familyId = $(this).data('familyid');
    fetchDefaultPackContents(familyId);
}

async function fetchDefaultPackContents(familyId) {
    try {
        loadSpinner();

        const result = await productService.getDefaultPackComponents({ familyId });

        if(result && result.IsSuccessful && result.PackProducts && result.PackProducts.length) {
            showPackContentsModal(result);
        } else {
            const message = result.ErrorMessage || GENERIC_ERROR_MESSAGE;
            toastUtil.Error(message, 3000);
            console.error(`[fetchDefaultPackContents] unable to retreive pack contents for family ID ${familyId}`, result);
        }
    } catch (ex) {
        toastUtil.Error(GENERIC_ERROR_MESSAGE, 3000);
        console.error(ex);
    }

    stopSpinner();
}

function showPackContentsModal(packContents) {
    let $isBPIndividualLinksFlow = $('#hidden-isBPIndividualLinksFlow');
    let $isBPBundleLinksFlow = $('#hidden-isBPBundleLinksFlow');
    let isInvidualFlowEnabled = false;
    let isBundleFlowEnabled = false;

    if($isBPIndividualLinksFlow.length > 0) {
        isInvidualFlowEnabled = $isBPIndividualLinksFlow.val() === 'true';
    }

    if($isBPBundleLinksFlow.length > 0) {
        isBundleFlowEnabled = $isBPBundleLinksFlow.val() === 'true';
    }

    if(isInvidualFlowEnabled || isBundleFlowEnabled) {
        packContents.IsRecommendedCart = false;
    } else {
        packContents.IsRecommendedCart = true;
    }

    const modalHtml = packContentsModalTemplate(packContents);
    $('body').append(modalHtml);
    $('#packContentsModal').modal('show');
    $('#packContentsModal').on('hidden.bs.modal', function () {
        $(this).remove();
    });
}
